export enum CRMLiteRowStatus {
  Pending = 'Pending',
  InProgress = 'In Progress',
  Completed = 'Completed',
  OnHold = 'On Hold',
  CallBack = 'Call Back'
}

export interface CRMLiteRow {
  id: string
  status: CRMLiteRowStatus
  createdAt: Date
  updatedAt: Date
  botId: string
  userId: string
  firstName: string
  lastName: string
  email: string
  phone: string
  address1: string
  address2: string
  city: string
  state: string
  zip: string

  storeName: string
  lastIntent: string

  notes: string
  tag: string
}
